import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).catch(err => {
      if (err.status === 401) {
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['/Login']);
      }
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.interceptor.ts